import {twMerge} from '../../../common/twMerge';
import {Dot} from '../../atoms/Dot/Dot';
import {Text} from '../../atoms/Text/Text';
import {MobileMainTabItemProps} from './MobileMainTabItemProps.interface';

export function MobileMainTabItem({
  children,
  hasDot = false,
  isActive = false,
  isEqualArrangeTab,
  className,
  ...props
}: MobileMainTabItemProps) {
  return (
    <div
      className={twMerge(
        'flex cursor-pointer select-none items-center justify-center pt-11pxr pb-10pxr',
        isEqualArrangeTab ? 'overflow-hidden px-10pxr' : 'px-4pxr',
        !isEqualArrangeTab && hasDot && 'pr-10pxr',
        isActive && 'border-b-2 border-solid border-theme-solid-100 pb-8pxr',
        className
      )}
      {...props}
    >
      <div className="relative flex max-w-full">
        <Text
          className={twMerge(
            'inline-block whitespace-nowrap text-center',
            isActive
              ? 'font-medium1-bold text-theme-solid-100'
              : 'font-medium1 text-theme-solid-60',
            isEqualArrangeTab && 'overflow-hidden text-ellipsis'
          )}
        >
          {children}
        </Text>
        {hasDot && <Dot className="absolute top-0 -right-6pxr" />}
      </div>
    </div>
  );
}
